export default __webpack_public_path__ + "styles/ArticleLinkButton.5ac697d5855816a78d1d6f76c2abfcaa.css";